import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
} from '@mui/material';
import { Lightbulb as LightbulbIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { AuditorRegistrationDetail } from '../types';

type ComeptencesProps = {
  auditorRegistrationDetail: AuditorRegistrationDetail;
};

const Competences = ({ auditorRegistrationDetail }: ComeptencesProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 2 }}>
      {auditorRegistrationDetail.commDecComps.length > 0 ? (
        <List>
          {auditorRegistrationDetail.commDecComps.map((commDecCom) => (
            <ListItem sx={{ px: 0 }} key={commDecCom.id}>
              <ListItemAvatar>
                <Avatar>
                  <LightbulbIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primaryTypographyProps={{ fontSize: '1.25rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
                primary={commDecCom.name}
                secondary={commDecCom.type}
              />
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography variant="subtitle1">
          {t('No competences', { defaultValue: 'No competences' })}
        </Typography>
      )}
    </Box>
  );
};

export default Competences;
